'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _generic = require('../../generic');

var _generic2 = _interopRequireDefault(_generic);

require('../styles/ToastMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ToastMessage = function ToastMessage(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ['className']);

  var classNames = 'cp-toast-message ' + className;

  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(_generic2.default, props)
  );
};

ToastMessage.propTypes = {
  className: _react.PropTypes.string
};

exports.default = ToastMessage;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/toast-message/components/ToastMessage.component.js
// module id = 1494
// module chunks = 1